module.exports = __webpack_public_path__ + "static/img/productu02.33c47556.png";